/**
 * 候场页：开了等候室时，非主持人先落在这里等主持人放行。
 *
 * 这一页要把「还在排队」说清楚。老系统没有等候室，进不去只有一句冷冰冰的
 * 错误提示；这里显示房间名、排在第几位、等了多久，并明确告诉用户
 * 「不用刷新，放行后会自动进入」—— 否则人会反复退出重连，反而排到后面。
 */

import { useEffect, useState } from 'react'

import { useRoomStore } from '../stores/roomStore'

export function Waiting({ onCancel }: { onCancel: () => void }) {
  const waiting = useRoomStore((s) => s.waiting)
  const [elapsed, setElapsed] = useState(0)

  useEffect(() => {
    const t = window.setInterval(() => setElapsed((n) => n + 1), 1000)
    return () => window.clearInterval(t)
  }, [])

  if (!waiting) return null

  return (
    <div className="waiting-page">
      <div className="wait-card">
        <div className="wait-spin" aria-hidden="true" />
        <h2>{waiting.name || '教室'}</h2>
        <p className="wait-main">已进入等候室，等待主持人允许你进入</p>
        <dl className="wait-meta">
          <dt>房间号</dt>
          <dd>{waiting.roomId}</dd>
          {waiting.position > 0 && (
            <>
              <dt>当前位置</dt>
              <dd>第 {waiting.position} 位</dd>
            </>
          )}
          <dt>已等待</dt>
          <dd>{fmt(elapsed)}</dd>
        </dl>
        <p className="wait-tip">不用刷新页面，主持人放行后会自动进入教室。</p>
        <button onClick={onCancel}>取消，返回登录</button>
      </div>
    </div>
  )
}

/** 秒数转 MM:SS。 */
function fmt(sec: number): string {
  const m = Math.floor(sec / 60)
  return `${String(m).padStart(2, '0')}:${String(sec % 60).padStart(2, '0')}`
}
